import { Resources } from 'constants/resources';

import { useMemo } from 'react';

import { useGetOne } from 'react-admin';
import { useWatch } from 'react-hook-form';
import { Method } from 'types/embedded/method';

import { useGatewayRulesMerchantDictionaryContext } from '../../context/GatewayRulesMerchantDictionaryContext';

export function useMethodChoices(mappingIndex: number) {
  const { methods, isLoadingMethods } = useGatewayRulesMerchantDictionaryContext();
  const methodId = useWatch({ name: `mappings.${mappingIndex}.method` });

  const isMethodInList = !methodId || methods.some((m) => m.id === methodId);

  // метод старого правила может отсутствовать среди методов мерчанта
  const { data: selectedMethod } = useGetOne<Method>(
    Resources.Methods,
    { id: methodId },
    {
      enabled: Boolean(methodId) && !isLoadingMethods && !isMethodInList,
    },
  );

  const methodChoices = useMemo(
    () => (selectedMethod && !isMethodInList ? [selectedMethod, ...methods] : methods),
    [methods, selectedMethod, isMethodInList],
  );

  return { methodChoices };
}
